import { type InputSample, type Vec3, viewDir } from "@rivalwatch/shared";

/**
 * Tooling hook (`window.__game.photo`, driven by scripts/hero-shots.ts and scripts/map-shots.ts):
 * holds buttons and walks without pointer lock, frames the local hero from any angle, or flies a
 * free camera anywhere. Inert until something sets it.
 */
export class PhotoRig {
  /** Btn bits held every frame, applied after the menu/pointer-lock gate. */
  buttons = 0;
  moveX = 0;
  moveZ = 0;
  /** Orbit the local hero instead of the shoulder camera. yaw 0 faces the hero, π is behind; radians. */
  orbit?: { yaw: number; pitch: number; dist: number; height?: number };
  /**
   * Free camera, over everything else. `fov` in radians; `ortho` (metres of view height) looks
   * straight down the -y axis in orthographic projection instead, centred on `look`.
   */
  fly?: { pos: Vec3; look: Vec3; fov?: number; ortho?: number };

  apply(s: InputSample) {
    s.buttons |= this.buttons;
    if (this.moveX || this.moveZ) {
      s.moveX = this.moveX;
      s.moveZ = this.moveZ;
    }
  }

  frame(rp: Vec3, heroYaw: number, heroHeight: number): { pos: Vec3; look: Vec3 } | undefined {
    const o = this.orbit;
    if (!o) return;
    const look = { x: rp.x, y: rp.y + (o.height ?? heroHeight * 0.55), z: rp.z };
    const d = viewDir(heroYaw + o.yaw, o.pitch);
    return { pos: { x: look.x + d.x * o.dist, y: look.y + d.y * o.dist, z: look.z + d.z * o.dist }, look };
  }
}
